module.exports = __webpack_public_path__ + "static/media/rpi.1c0fe76a.svg";